import foundInFields from '../../utils/foundInFields';

const filterGrants = (grants, activeFilters) => grants
  .filter((grant) => activeFilters.reduce((acc, { type, value }) => {
    // If this post is already marked as not matching, don't check further.
    if (! acc) {
      return acc;
    }

    const {
      communities = [],
      programs: programAreas = [],
      started_on: startedOn = '',
    } = grant;

    // Fork for type of filter.
    switch (type) {
      case 'keyword':
        return foundInFields(
          value,
          grant,
          [
            'name',
            'description',
            'communities',
            'programs',
            'challenges',
            'grantees',
          ]
        );
      case 'communities':
        return communities.includes(value);
      case 'program-areas':
        return programAreas.some(({ name }) => name === value);
      case 'years':
        return startedOn.substring(0, 4) === value;
      default:
        break;
    }

    return acc;
  }, true));

export default filterGrants;
